// application/useDescargarPdf.js  (descarga con estado de carga; ignora llamadas mientras hay una en curso). Sin DOM ni Swal.
import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * useDescargarPdf(descargar) -> { descargar: async (uuid) => { blob, nombre } | null, descargando }
 * `descargar` es el método del repositorio (uuid -> { blob, nombre }). Relanza el DomainError para que la ui lo muestre.
 */
export const useDescargarPdf = descargarRepo => {
  const [descargando, setDescargando] = useState(false);
  const enCurso = useRef(false);
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  const descargar = useCallback(
    async uuid => {
      if (enCurso.current) return null;
      enCurso.current = true;
      setDescargando(true);
      try {
        return await descargarRepo(uuid);
      } finally {
        enCurso.current = false;
        if (mounted.current) setDescargando(false);
      }
    },
    [descargarRepo]
  );

  return { descargar, descargando };
};

export default useDescargarPdf;
